<div class="popup-container" [class.rotate-screen]="isRotateScreen" (click)="$event.stopPropagation()"
  [class.show-content]="showContent">

  <div class="close-btn-mobile" (click)="closeOverlay()">
    <img alt="Close" src="/assets/icons/close-icon.svg">
  </div>

  @for (action of actions; track action) {
    <div class="popup-btn"
      [class.suggested-action]="action.Id === suggestedAction?.Id"
      (click)="onBtnClick(action)"
      (mouseover)="hovered.src = actionHelper.getActionIconUrl(action.Name, false)"
      (mouseout)="hovered.src = actionHelper.getActionIconUrl(action.Name, action.Id !== suggestedAction?.Id)">
      <div class="btn-icon" [ngClass]="actionHelper.getActionClassName(action.Name)">
        <img #hovered [src]="actionHelper.getActionIconUrl(action.Name, action.Id !== suggestedAction?.Id)" alt="icon"
          matTooltip="{{action?.Label}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
      </div>
      <div class="btn-text">{{action.Label}}</div>
    </div>
  }

  @if (isDuplicateLead) {
    <div class="popup-btn" (click)="onDuplicateBtnClick()">
      <div class="btn-icon duplicate">
        <img src="/assets/icons/duplicate.svg" alt="duplicate-icon">
      </div>
      <div class="btn-text" #duplicate [isTitle]="true" fiTranslation="ALT_TEXT_DUPLICATE_CHECK"
        matTooltip="{{duplicate.dataset.matTooltip}}" matTooltipPosition="below"
        matTooltipClass='tooltip-style'><span fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></span></div>
      </div>
    }

    <a class="popup-link arow" (click)="emitMarkAsRead()">
      <img alt="Arow right" src="/assets/icons/arrow-right.svg">
      <span class="link-text" fiTranslation="REQUEST_OVERVIEW_DETAIL"></span><span class="space"></span>
    </a>

    @if (read) {
      <mat-divider class="unread-divider"></mat-divider>
    }

    @if (read) {
      <div class="unread">
        <a class="popup-link" (click)="emitMarkAsUnread()">
          <div class="eye_icon">
            <img src="/assets/icons/eye.svg" alt="eye-icon">
          </div>
          <span class="link-text" fiTranslation="REQUEST_OVERVIEW_DETAIL_UNREAD"></span>
        </a>
      </div>
    }

  </div>
